module.exports = __webpack_public_path__ + "static/media/toasterIcon.74370fb1.svg";